"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepMemo = void 0;
/**
 * Adapted from https://usehooks.com/useMemoCompare/,
 * this hook lets us memoize an instance of a compound value (object, array)
 * based on deep equality, such that we can keep its object identity stable across re-renders.
 *
 * This is primarily intended for use by hooks that accept props objects.
 * Without this hook, all clients would have to memoize their props objects
 * or cause the hook to re-run on every render. Using this hook to memoize
 * the hook arguments allows clients to define the props inline with
 * minimal performance penalty.
 *
 * Usage example:
 *
 * const useMyHook = (options: { foo: "string", bar: number }) => {
 *   const memoizedOptions = useDeepMemo(options);
 *   useEffect(() => {
 *     // this effect hook will only run when the _contents_ of options changes
 *   }, [memoizedOptions])
 * }
 *
 * // calling the hook like this would cause the effect to re-run on
 * // every render if we hadn't used `useDeepMemo`.
 * useMyHook({ foo: "baz", bar: 3 })
 */
const react_1 = require("react");
const es_toolkit_1 = require("es-toolkit");
const useDeepMemo = (next) => {
    const previousRef = (0, react_1.useRef)();
    const previous = previousRef.current;
    const changed = !(0, es_toolkit_1.isEqual)(previous, next);
    (0, react_1.useEffect)(() => {
        if (changed) {
            previousRef.current = next;
        }
    });
    return changed || !previous ? next : previous;
};
exports.useDeepMemo = useDeepMemo;
//# sourceMappingURL=useDeepMemo.js.map